import { useNavigate } from 'react-router-dom';
import '../styles/page.css';
import { useEffect, useState } from 'react';
import { IDocumentDetail } from '../../interface/document';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { IFileInfo } from '../../interface/common';

function DocumentDetail() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const boardSeq = searchParams.get('boardSeq');

  const [documentDetail, setDocumentDetail] = useState<IDocumentDetail>();
  const [prevData, setPrevData] = useState<IDocumentDetail>();
  const [nextData, setNextData] = useState<IDocumentDetail>();
  const [fileList, setFileList] = useState<IFileInfo[]>([]);

  // 공지사항 목록으로 이동
  const hadleList = () => {
    navigate(`/document`);
  };

  const handleSearch = async () => {
    await fetch(`/document/detail?boardSeq=${boardSeq}`, {
      method: 'GET',
      headers: { 'Content-Type': 'applications/json' },
    })
      .then((response) => response.json())
      .then((result) => {
        setDocumentDetail(result);
        setFileList(result.attachFiles);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  // 자료실 '이전글'로 이동
  const handlePrev = () => {
    navigate(`/document-detail?boardSeq=${prevData?.boardSeq}`);
    navigate(0);
  };

  // 자료실 '다음글'로 이동
  const handleNext = () => {
    navigate(`/document-detail?boardSeq=${nextData?.boardSeq}`);
    navigate(0);
  };

  // 첨부파일 개별 다운로드 >>> .crdownload 문제때문에 fetch 방식으로 수정
  // const handleFileDownload = async (fieSeq: string | undefined) => {
  //   if (fieSeq) {
  //     const fileInfo = fileList?.filter((item) => item.fileSeq === fieSeq);
  //     if (fileInfo) {
  //       const param = encodeURIComponent(JSON.stringify(fileInfo));
  //       window.location.href = `/common/fileDownload?fileList=${param}`;
  //     }
  //   }
  // };

  const handleFileDownload = async (fileSeq: string | undefined) => {
    if (!fileSeq) return;

    const fileInfo = fileList?.find((item) => item.fileSeq === fileSeq);
    if (!fileInfo) return;

    const param = encodeURIComponent(JSON.stringify([fileInfo]));
    const fileUrl = `/common/fileDownload?fileList=${param}`;

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();

      // 파일명 추출 (Content-Disposition에서 filename 추출)
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'downloaded-file';

      if (disposition) {
        const match = disposition.match(/filename\*=UTF-8''(.+)/);
        if (match?.[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      alert('파일 다운로드에 실패했습니다.');
    }
  };

  // 첨부파일 일괄 다운로드 >>> .crdownload 문제때문에 fetch 방식으로 수정
  // const handleZipDownload = async (attachCd: string | undefined) => {
  //   if (attachCd) {
  //     const param = encodeURIComponent(JSON.stringify(fileList));
  //     window.location.href = `/common/zipDownload?fileList=${param}`;
  //   }
  // };

  const handleZipDownload = async (attachCd: string | undefined) => {
    if (!attachCd) return;

    const fileInfo = fileList;
    if (!fileInfo || fileInfo.length === 0) return;

    const param = encodeURIComponent(JSON.stringify(fileInfo));
    const fileUrl = `/common/zipDownload?fileList=${param}`;

    // 파일명 생성
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const filename = year + month + day + hours + minutes + '.zip';

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      alert('ZIP 다운로드에 실패했습니다.');
    }
  };

  useEffect(() => {
    // 자료실 이전글/다음글 세팅
    fetch(`/document/list?searchTitle=`)
      .then((response) => response.json())
      .then((result) => {
        const index = result?.findIndex(
          (item: { boardSeq: string | null }) => item.boardSeq === boardSeq,
        );
        if (index !== -1) {
          const prevObj: IDocumentDetail = result[index + 1];
          const nextObj: IDocumentDetail = result[index - 1];
          setPrevData(prevObj);
          setNextData(nextObj);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [documentDetail]);

  useEffect(() => {
    AOS.init();
    handleSearch();
  }, []);

  return (
    <>
      <section id="notice-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              자료실
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              제품 및 서비스 관련 자료를 다운로드 할 수 있습니다.
            </p>
          </div>
        </div>
      </section>

      <main id="notice-detail">
        <div className="notice-detail-container m-auto">
          <div className="notice-detail-title">
            <p className="fs-md">{documentDetail?.boardTitle}</p>
            <div className="notice-detail-infobox">
              <div className="notice-detail-infotext">
                <span>등록일</span>
                <span>{documentDetail?.regDt?.substring(0, 11)}</span>
              </div>
              <div className="notice-detail-infotext">
                <span>조회수</span>
                <span>
                  {documentDetail?.readCnt === null || documentDetail?.readCnt === undefined
                    ? '1'
                    : Number(documentDetail?.readCnt) + 1}
                </span>
              </div>
            </div>
          </div>
          {undefined != fileList && fileList.length !== 0 ? (
            <div className="download-file-box">
              <div className="download-file-title">
                <div className="notice-detail-infotext">
                  <span>첨부파일</span>
                  <span>{fileList.length}건</span>
                </div>
                <button
                  className="download-file-btn"
                  type="button"
                  onClick={(e) => {
                    handleZipDownload(fileList[0]?.attachCd);
                  }}
                >
                  <span className="download-file-icon02"></span>
                  <p>전체다운로드</p>
                </button>
              </div>

              {fileList.map((item) => (
                <div key={item.fileSeq}>
                  <div className="download-file-item">
                    <a onClick={(e) => handleFileDownload(item.fileSeq)}>
                      <span className="download-file-icon"></span>
                      <span>{item?.fileNm}</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            ''
          )}

          <div className="notice-detail-body">
            {documentDetail?.boardTxt
              ?.replace(/<(?!\/p)[^>]+>/g, '')
              .replaceAll('</p>', '\n')
              .replaceAll('&nbsp;', '')}
          </div>
          <div className="notice-nav-box">
            <div className="notice-nav">
              <div className="notice-nav-head">
                <span className="mr-4">이전글</span>
                <img src="./images/ico-notice-up.svg" alt="" />
              </div>
              <div className="notice-nav-body">
                {undefined !== prevData ? (
                  <a className="" onClick={handlePrev}>
                    {prevData?.boardTitle}
                  </a>
                ) : (
                  <a className="">-</a>
                )}
              </div>
            </div>
            <div className="notice-nav">
              <div className="notice-nav-head">
                <span className="mr-4">다음글</span>
                <img src="./images/ico-notice-down.svg" alt="" />
              </div>
              <div className="notice-nav-body">
                {undefined !== nextData ? (
                  <a className="" onClick={handleNext}>
                    {nextData?.boardTitle}
                  </a>
                ) : (
                  <a className="">-</a>
                )}
              </div>
            </div>
          </div>
          <div className="notice-btn-box">
            <button type="button" onClick={hadleList}>
              목록으로
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

export default DocumentDetail;
